import { createAction, props } from '@ngrx/store';

export enum PayWithPointsActions {
  getBalance = '[Pay With Points] Get balance',
  getBalanceSuccess = '[Pay With Points] Get balance success',
  getBalanceFail = '[Pay With Points] Get balance fail',
}

export const getBalance = createAction(PayWithPointsActions.getBalance);
export const getBalanceSuccess = createAction(PayWithPointsActions.getBalanceSuccess, props<{ points: number }>());
export const getBalanceFail = createAction(PayWithPointsActions.getBalanceFail);
